import React, { useRef, useEffect } from "react";

export const TextAreaInputComponent = ({
  value,
  changeValue,
  name,
  id,
  required = false,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref?.current) {
      ref.current.style.height = "0px";
      const scrollHeight = ref.current.scrollHeight;
      ref.current.style.height = scrollHeight + "px";
    }
  }, [value]);

  return (
    <div className="bg-white px-10 sm:px-20 py-5 sm:py-10 rounded-xl border-l-4 border-[#5d5df1] mb-3">
      <label htmlFor={id} className="font-medium">
        {name}
      </label>
      {required ? <label className="text-[red] pl-1">*</label> : <></>}
      <br />
      <textarea
        ref={ref}
        required={required}
        className="outline-none border-b border-gray-500 w-4/5 sm:w-3/5 mt-5 transition-all duration-300 focus:border-[#1976D2] focus:border-b-2 scroll"
        type="text"
        id={id}
        value={value}
        placeholder={name}
        onChange={(event) => changeValue(event.target.value)}
      ></textarea>
    </div>
  );
};
